import { img, mainWrap, reverse, reverseTitle, title, wrap } from "./imageAndText.css"

type Props = {
  items: {
    imgUrl: string
    imgAlt: string
    imgTitle?: string
    text: string
  }[]
}

function ImageAndText({ items }: Props) {
  return (
    <div className={mainWrap}>
      {items.map((item, i) => {
        const inverted = (i + 1) % 2 === 0
        return (
          <div className={`${wrap} ${inverted ? reverse : ""}`} key={item.text}>
            <p className={`${title} ${reverseTitle}`}>{item.text}</p>
            <img
              src={item.imgUrl}
              alt={item.imgAlt}
              title={item.imgTitle}
              className={img}
              loading="lazy"
            />
          </div>
        )
      })}
    </div>
  )
}

export default ImageAndText
